import styles from './RetailCatalogDetail.module.scss'
import { Fragment, ReactElement, useCallback, useEffect, useMemo, useState } from 'react'
import Menu from '@/components/Menu/Menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight, faPlus, faMagnifyingGlass, faRing, faGem, faBox, faCubesStacked } from '@fortawesome/free-solid-svg-icons'
import { faGrid2, faGrid, faBars, faBarsFilter } from '@fortawesome/pro-solid-svg-icons'
import RetailCatalogSearchBar from '@/components/Catalog/RetailCatalogSearchBar'
import Button from '@/components/Button'
import ButtonLink from '@/components/ButtonLink'
import QtyPickerRetail from '@/components/QtyPickerRetail'
import ListRetailItem from '@/components/Catalog/ListRetailItem'
import { useNavigate } from 'react-router-dom'
import useTranslation from '@/Hooks/useTranslation'
import useCollections from '@/Hooks/useCollections'
import useRetailFilters from '@/Hooks/useRetailFilters'
import useRetailCollections from '@/Hooks/useRetailCollections'
import usePrefStore from '@/stores/prefs'
import useTarifs from '@/Hooks/useTarifs'
import RadioButtons, { SingleRadioButton } from '@/components/RadioButtons'
import DropdownField from '@/components/DropdownField'
import CardRetailModel from '@/components/CardRetailModel'
import PagesButtons from '@/components/PagesButtons'
import useHelpers from '@/Hooks/useHelpers'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import useStateWithHistory from '@/Hooks/useStateWithHistory' // TRES COMPLIQUÉ AVEC CATALOG_DETAIL !!! OK seulement sur qq states
import useScrollBlock from "@/Hooks/useScrollBlock";
import useSales from '@/Hooks/useSales'
import useRetailCatalogScope from '@/Hooks/useRetailCatalogScope'
import Confirm from '@/components/Confirm'
import type { OrderLine } from '@/types'
import { RetailCatalogFilterContext } from '@/Contexts/RetailCatalogFilterContext';
import { GlobalContext } from '@/Contexts/GlobalContext'
import DynImage from '@/components/DynImage'
// import glob_const from '@/libs/glob_const';
import type { RetailModel, Model } from '@/types'

const modeList = 'radbtn_list'
const modeGrid = 'radbtn_grid'
const modeSmallGrid = 'radbtn_smallgrid'

const sortFamille = 'sort_famille'
const sortGamme = 'sort_gamme'
const sortAsc = 'sort_asc'
const sortDesc = 'sort_desc'

function RetailCatalogDetail() {
   // Prefs store
   const listPageLength = Math.min(100, Number(usePrefStore((state) => state.listPageLength)))
   const { minFilterLength, setListPageLength, curOrder, curCustomer } = usePrefStore()

   // States mémo pour historique
   const [displayMode, setDisplayMode] = useStateWithHistory('catdet_display_mode', modeGrid)

   // *******************************************
   // Pour éviter les rerenders, on décide du moment où le filtrage peut se faire.
   // Il peut se faire quand le bouillonnement de la mise à jour Gammes > Collections > Familles est fini
   // const [doFilter, setDoFilter] = useState(false)
   // Variables/fonctions de contexte. Le tweak {...} est en cas de undefined avec CatalogFilterContext()
   const { setDoFilter, getSelectedGammesIds, getSelectedCollectionsIds, getSelectedFamillesIds, getSelectedCyclesIds, searchText, paramCollectionId, paramFamilleId, getSelectedTypologiesIds, excluBoutique, allMinMax, minManualPrice, maxManualPrice, minPrice, maxPrice } = { ...RetailCatalogFilterContext() } as any
   const { isDarkLayerVisible, setIsDarkLayerVisible, setKeepSearchBarAccessible } = { ...GlobalContext() } as any

   // States
   const [curPage, setCurPage] = useState(1)
   const [nbPages, setNbPages] = useState(1)
   const [firstPage, setFirstPage] = useState(1)
   const [, setMainSortMode] = useState<string | null>(null)
   const [subSortOrder, setSubSortOrder] = useStateWithHistory('retail_catdet_sub_sort_order', sortAsc)
   const [selectedModelId, setSelectedModelId] = useState<string | null>(null)
   const [selectedModel, setSelectedModel] = useState<Model | null>(null)
   const [filteredList, setFilteredList] = useState<RetailModel[]>([])  // Les objets des modèles à afficher (avant searchText)
   const [finalList, setFinalList] = useState<RetailModel[] | null>(null)        // Les objets des modèles réellement affichés (après searchText)

   const [subTitle, setSubTitle] = useState<string | null>(null)
   const [modelItems, setModelItems] = useState<ReactElement[] | null>(null)
   // sortSegItems retiré (plus de tri par gamme/famille/collection en retail)
   // const [searchBar, setSearchBar] = useState(null)
   const [catSearchBar, setCatSearchBar] = useState<ReactElement | null>(null)
   const [isQtyPickerVisible, setIsQtyPickerVisible] = useState(false) //16
   const [isItemsPerPageOpen, setIsItemsPerPageOpen] = useState(false)
   const [items, setItems] = useState<RetailModel[] | null>(null)
   const [pagesButtons, setPagesButtons] = useState<ReactElement | null>(null)
   const [critSummerize, setCritSummerize] = useState<string | null>(null)
   const [showInfoDown, setShowInfoDown] = useState(false)    // true = animer l'affichage, false = animer le masquage
   const [isInfoVisible, setIsInfoVisible] = useState(false)   // info présent ou absent de la page
   const [theQtyPicker, setTheQtyPicker] = useState<ReactElement | null>(null)   // info présent ou absent de la page
   const [duplicateLineDialog, setDuplicateLineDialog] = useState<{ line: OrderLine, existingQty: number } | null>(null)
   const [selectedThumb, setSelectedThumb] = useState<number | undefined>()   // Indice de la vignette choisie dans la fiche détail
   const [zoomed, setZoomed] = useState(false)   // Affichage des vignettes en mode Zoomé
   // const [refreshFilterTimer, setRefreshFilterTimer] = useState(null)
   //
   const navigate = useNavigate()
   const { trans, lowtrans, transWithParams } = useTranslation()
   const { getCollectionById, getModelById } = useCollections()
   const { getCessPriceForModelColorSize } = useTarifs()
   const { formatPPUPrice } = useHelpers()
   const { filterOnText, filterOnCriteria, filterOnPrice } = useRetailFilters()
   const { getRetailFamilleById, getRetailTypologieById, isRetailModelVisibleForCustomer } = useRetailCollections()
   const { createOrUpdateLinesInOrder, createOrder, makeTemplateOrder, getRetailOrderType, getCustomerById, getOrderById, type_order } = useSales()
   const [blockScroll, allowScroll] = useScrollBlock();

   useEffect(() => {
      setMainSortMode((paramCollectionId || paramFamilleId) ? sortFamille : sortGamme)
   }, [paramCollectionId, paramFamilleId])

   const sortList = useCallback((arr) => {
      // Tri retail : Famille (alpha) > Typologie (alpha) > Prix (asc/desc)
      const dir = subSortOrder === sortAsc ? 1 : -1
      return [
         ...arr.sort((item1, item2) => {
            const fam1 = getRetailFamilleById(item1.fam)?.label ?? ''
            const fam2 = getRetailFamilleById(item2.fam)?.label ?? ''
            let ret = fam1.localeCompare(fam2)
            if (ret === 0) {
               const typo1 = getRetailTypologieById(item1.typo)?.label ?? ''
               const typo2 = getRetailTypologieById(item2.typo)?.label ?? ''
               ret = typo1.localeCompare(typo2)
               if (ret === 0) {
                  const p1 = allMinMax?.[item1.id]?.min ?? 0
                  const p2 = allMinMax?.[item2.id]?.min ?? 0
                  ret = (p1 - p2) * dir
                  if (ret === 0) {
                     ret = (item1.label ?? '').localeCompare(item2.label ?? '')
                  }
               }
            }
            return ret
         })
      ]
   }, [subSortOrder, allMinMax, getRetailFamilleById, getRetailTypologieById])

   // Scope catalogue Retail (type client effectif + customer à passer à la grille) :
   // cf. Hooks/useRetailCatalogScope pour la règle complète.
   const { customerType: effectiveCustomerType, customerForGrid } = useRetailCatalogScope()

   const hasExcluBoutique = useMemo(() => {
      const customer = curCustomer ? getCustomerById(curCustomer) : null
      return customer?.exclu_boutique != null
   }, [curCustomer, getCustomerById])

   /**************
    ************** FILTRAGE FINAL !!!
    **************/
   useEffect(() => {
      const selected_familles_id = getSelectedFamillesIds()
      const selected_gammes_id = getSelectedGammesIds()
      const selected_collections_id = getSelectedCollectionsIds()
      const selected_typologies_id = getSelectedTypologiesIds()
      const selected_cycles_id = getSelectedCyclesIds()

      let arr = filterOnCriteria({ gammes: selected_gammes_id, collections: selected_collections_id, familles: selected_familles_id, typologies: selected_typologies_id, cycles: selected_cycles_id, exclusivite: excluBoutique })

      // Filtrage de visibilité selon le type client
      arr = arr.filter(model => isRetailModelVisibleForCustomer(model, effectiveCustomerType, hasExcluBoutique, customerForGrid))
      // console.log('+++filterOnCriteria result:', arr.length, 'modèles')

      // Filtrage sur le prix si allMinMax disponible
      if (allMinMax) {
         const filterMinPrice = (((minManualPrice !== null) && (minManualPrice >= minPrice)) ? minManualPrice : null)
         const filterMaxPrice = (((maxManualPrice !== null) && (maxManualPrice <= maxPrice)) ? maxManualPrice : null)

         arr = filterOnPrice(arr, { price_min: filterMinPrice, price_max: filterMaxPrice }, allMinMax)
      }

      setFilteredList(arr)
   }, [allMinMax, effectiveCustomerType, excluBoutique, filterOnCriteria, filterOnPrice, getSelectedCollectionsIds, getSelectedCyclesIds, getSelectedFamillesIds, getSelectedTypologiesIds, getSelectedGammesIds, hasExcluBoutique, customerForGrid, isRetailModelVisibleForCustomer, maxManualPrice, maxPrice, minManualPrice, minPrice])

   useEffect(() => {
      if (finalList?.length) {
         const len = listPageLength
         const max = Math.floor((finalList.length + len - 1) / len) // Nb maxi de pages
         setNbPages(max)
         // console.log('>>>>>>', max, finalList.length, finalList.length + len, listPageLength)
         if (curPage < 1 || curPage > max) {
            setCurPage(1)
         }
      }
   }, [curPage, finalList, listPageLength, setCurPage, setNbPages])

   useEffect(() => {
      const selected_gammes_id = getSelectedGammesIds()
      const selected_collections_id = getSelectedCollectionsIds()
      const selected_familles_id = getSelectedFamillesIds()
      const selected_typologies_id = getSelectedTypologiesIds()

      let arr = [];

      if ((paramCollectionId === null) && (selected_gammes_id.length > 0)) {
         arr.push(`${selected_gammes_id.length} ${lowtrans('?Gamme', selected_gammes_id.length)}`)
      }
      if ((paramCollectionId === null) && (selected_collections_id.length > 0)) {
         arr.push(`${selected_collections_id.length} ${lowtrans('?Collection', selected_collections_id.length)}`)
      }
      if (selected_familles_id.length > 0) {
         arr.push(`${selected_familles_id.length} ${lowtrans('?Famille', selected_familles_id.length)}`)
      }
      if (selected_typologies_id.length > 0) {
         arr.push(`${selected_typologies_id.length} ${lowtrans('?Typologie', selected_typologies_id.length)}`)
      }

      const subtitle_parts = []

      setCritSummerize((arr.length > 0) ?
         `(${arr.length} ${lowtrans('?Filtre', arr.length)} : ${arr.join(', ')})` :
         null)

      if (selected_familles_id.length > 1) {
         setSubTitle(`${selected_familles_id.length} ${lowtrans('?Famille', true)}`)
      } else if (selected_familles_id.length === 1) {
         setSubTitle(getRetailFamilleById(selected_familles_id[0])?.label ?? selected_familles_id[0])
      } else {
         setSubTitle(trans("?Toutes familles"))
      }

      if (subtitle_parts.length > 0) { setSubTitle(subtitle_parts.join(', ')) }
   }, [paramCollectionId, paramFamilleId, formatPPUPrice, getCollectionById, getRetailFamilleById, getSelectedCollectionsIds, getSelectedFamillesIds, getSelectedGammesIds, lowtrans, trans, getSelectedTypologiesIds])

   useEffect(() => {
      const start = (curPage - 1) * listPageLength;
      setItems(finalList?.slice(start, start + listPageLength))
   }, [curPage, finalList, listPageLength])

   // useEffect(() => {
   //    console.log('***Items', items);
   // }, [items])

   const onFirstPageChange = useCallback((val) => {
      // console.log('onFirstPageChange', val)
      setFirstPage(val)
   }, [setFirstPage])

   const onPageChange = useCallback((val) => {
      setCurPage(val)
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }, [setCurPage])

   useEffect(() => {
      setPagesButtons(
         <PagesButtons from={firstPage} max={nbPages} selected={curPage} onFirstPageChange={onFirstPageChange} onPageChange={onPageChange} ></PagesButtons>
      )
   }, [curPage, firstPage, nbPages, onFirstPageChange, onPageChange])

   useEffect(() => {
      setKeepSearchBarAccessible(false)
      setIsDarkLayerVisible(isQtyPickerVisible)
   }, [isQtyPickerVisible, setIsDarkLayerVisible, setKeepSearchBarAccessible])

   useEffect(() => {
      if (!isDarkLayerVisible) {
         setIsQtyPickerVisible(false)
      }
   }, [isDarkLayerVisible])

   const onShowQtyPicker = useCallback((model_id) => {
      if (effectiveCustomerType === 'NONE') return
      // console.log(`onShowQtyPicker(${model_id})`)
      setSelectedModelId(model_id)
      setIsQtyPickerVisible(true)
   }, [effectiveCustomerType])

   function doHideInfo() {
      setShowInfoDown(false)
      // On supprime le panneau de la page pour alléger le code
      setTimeout(() => {
         setIsInfoVisible(false)
      }, 300)  // Si changement de 300, changer aussi dans CSS ()
   }

   const onShowDetail = useCallback((model_id) => {
      // console.log(`onShowDetail(${model_id})`)
      setSelectedModelId(model_id)
      setSelectedModel(getModelById(model_id))
      setIsInfoVisible(true)
      setSelectedThumb(0)
      setZoomed(false)
   }, [getModelById])

   useEffect(() => {
      let arr = [];

      // console.log(items);

      if (displayMode === modeList) {
         arr = items?.map((model) => {
            return (<ListRetailItem key={model.id} id={model.id} onShowQtyPicker={onShowQtyPicker} onShowDetail={onShowDetail} />)
         })
      } else {
         arr = items?.map((model) => {
            return (
               <CardRetailModel key={`card-${model.id}`} id={model.id} onClick={onShowQtyPicker} small={displayMode === modeSmallGrid} />
            )
         })
      }
      setModelItems(arr)
   }, [displayMode, items, onShowDetail, onShowQtyPicker])

   function goCatalog() {
      navigate('/catalog', { replace: true })
   }

   const hideQtyPicker = useCallback(() => {
      setIsQtyPickerVisible(false)
   }, [])

   useEffect(() => {
      let arr

      if (searchText?.length >= minFilterLength) {
         arr = sortList(filterOnText(filteredList, searchText))
      } else {
         arr = sortList(filteredList)
      }
      setFinalList(arr)
   }, [filterOnText, filteredList, minFilterLength, searchText, sortList])

   function onSortOrderClick() {
      setSubSortOrder(subSortOrder === sortAsc ? sortDesc : sortAsc)
   }

   function onDisplayModeWillChange(which) {
      setDisplayMode(which)
   }

   function toggleItemsPerPageShowList() {
      setIsItemsPerPageOpen(!isItemsPerPageOpen)
   }

   function onItemsPerPageSelect(id) {
      setListPageLength(id)
      setIsItemsPerPageOpen(false)
   }

   async function addNewOrder() {
      const customer = curCustomer ? getCustomerById(curCustomer) : null
      const orderType = getRetailOrderType(customer)
      if (!orderType) return
      const new_order = makeTemplateOrder(curCustomer)
      new_order.type = orderType === 'ECR' ? type_order.retail_interne : type_order.retail_externe
      const curid = await createOrder(new_order)

      // On a la même chose (avec Toaster dans Customers.jsx)
      toast.success(transWithParams('?Nouvelle commande %1 créée et activée', curid), {
         position: "top-right",
         autoClose: 2500,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: true,
         draggable: true,
         // progress: ,
         theme: "colored",
      });
   }

   // multi ne sert à rien dans Retail mais il faut rester compatible avec le Picker Bjx
   const addLines = useCallback(async (model, multi, variations) => {
      // Retail : une seule variation (qty unique pour ce SKU)
      const variation = variations?.[0]
      if (!variation) return
      // Retail : prix de CESSION (cohérent avec l'affichage picker/liste/détail et avec
      // OrderDetail). NE PAS utiliser getPriceForModelColorSize (= public/PPU).
      const price = getCessPriceForModelColorSize(model, undefined, undefined, undefined, undefined)?.price ?? 0
      const line: OrderLine = { sku: model, qty: variation.qty, price }

      // Si SKU déjà présent dans la commande → afficher la popup Remplacer/Cumuler/Annuler
      if (curOrder) {
         const order = await getOrderById(curOrder)
         const existing = (order?.lines ?? []).find(l => l.sku === model && !l.comment)
         if (existing) {
            setDuplicateLineDialog({ line, existingQty: existing.qty })
            return
         }
      }
      createOrUpdateLinesInOrder(curOrder, [line])
   }, [createOrUpdateLinesInOrder, curOrder, getCessPriceForModelColorSize, getOrderById])

   const onReplaceDuplicate = useCallback(() => {
      if (!duplicateLineDialog) return
      createOrUpdateLinesInOrder(curOrder, [duplicateLineDialog.line])
      setDuplicateLineDialog(null)
   }, [createOrUpdateLinesInOrder, curOrder, duplicateLineDialog])

   const onCumulateDuplicate = useCallback(() => {
      if (!duplicateLineDialog) return
      const { line, existingQty } = duplicateLineDialog
      createOrUpdateLinesInOrder(curOrder, [{ ...line, qty: existingQty + line.qty }])
      setDuplicateLineDialog(null)
   }, [createOrUpdateLinesInOrder, curOrder, duplicateLineDialog])

   const onCancelDuplicate = useCallback(() => {
      setDuplicateLineDialog(null)
   }, [])

   useEffect(() => {
      setCatSearchBar(<RetailCatalogSearchBar onFilter={() => setDoFilter(true)} />)
   }, [setDoFilter])

   useEffect(() => {
      if (isInfoVisible) {
         blockScroll()
         setShowInfoDown(true)
      } else {
         allowScroll()
      }
      return () => {
         allowScroll()
      }
   }, [allowScroll, blockScroll, isInfoVisible])

   useEffect(() => {
      if (isQtyPickerVisible) {
         setTheQtyPicker(<QtyPickerRetail customer={curCustomer} model={selectedModelId} onHide={hideQtyPicker} onAdd={addLines} />)
      } else {
         setTheQtyPicker(null)
      }
   }, [addLines, curCustomer, hideQtyPicker, isQtyPickerVisible, selectedModelId])

   return (
      <Fragment>
         <Menu page="catalog" />
         <div className={styles.retail_catalog_detail}>
            {catSearchBar}
            <div className={styles.content}>
               <header>
                  <ButtonLink lefticon={<FontAwesomeIcon icon={faAngleLeft} />} onClick={goCatalog} >
                     {trans('?Retour au catalogue')}
                  </ButtonLink>
                  {effectiveCustomerType !== 'NONE' && (curCustomer === null) &&
                     <Button disabled lefticon={<FontAwesomeIcon icon={faPlus} />}>
                        {trans('?Aucun client sélectionné')}
                     </Button>
                  }
                  {effectiveCustomerType !== 'NONE' && (curCustomer !== null) &&
                     <Button lefticon={<FontAwesomeIcon icon={faPlus} />} onClick={addNewOrder}>
                        {trans('?Nouvelle commande')}
                     </Button>
                  }
                  <h1>{subTitle}</h1>
                  <div className={styles.sort_mode}>
                     <span>{trans('?Prix')} :</span>
                     {subSortOrder === sortAsc && (
                        <SingleRadioButton selected onClick={onSortOrderClick}>
                           <FontAwesomeIcon key={sortAsc} icon={faBarsFilter} style={{ transform: 'rotate(180deg)' }} />
                        </SingleRadioButton>
                     )}
                     {subSortOrder === sortDesc && (
                        <SingleRadioButton selected onClick={onSortOrderClick}>
                           <FontAwesomeIcon key={sortDesc} icon={faBarsFilter} />
                        </SingleRadioButton>
                     )}
                  </div>
                  <span className={styles.filtered_count}>
                     {finalList?.length ?? 0}{' '}
                     {lowtrans('?Modèle', finalList?.length)}
                     {(searchText?.trim().length > 0) ? ` ${trans('?x_sur_y')} ${filteredList.length}` : ''}{' '}
                     {critSummerize}
                  </span>
                  <div className={styles.display_mode}>
                     <RadioButtons selected={(displayMode === modeList) ? modeList : ((displayMode === modeGrid) ? modeGrid : modeSmallGrid)} onWillChange={onDisplayModeWillChange} >
                        <FontAwesomeIcon key={modeList} icon={faBars} />
                        <FontAwesomeIcon key={modeGrid} icon={faGrid2} />
                        <FontAwesomeIcon key={modeSmallGrid} icon={faGrid} />
                     </RadioButtons>
                  </div>
                  <span className={styles.path}>
                     {trans('?Famille')} <FontAwesomeIcon icon={faAngleRight} /> {trans('?Typologie')} <FontAwesomeIcon icon={faAngleRight} /> {trans('?Prix')}
                  </span>
               </header>
               <section className={`${displayMode === modeList ? styles.list : styles.grid} ${displayMode === modeSmallGrid ? styles.small : ''}`}>
                  {modelItems}
               </section>
            </div>
            <div className={styles.footer_bg}>
               <div className={styles.footer}>
                  <span>{trans('?Affichage de')}</span>
                  <DropdownField selectedValue={String(listPageLength)} showAbove height={36} onSelect={onItemsPerPageSelect} isOpen={isItemsPerPageOpen} onToggle={toggleItemsPerPageShowList}>
                     <Fragment key="10">10</Fragment>
                     <Fragment key="20">20</Fragment>
                     <Fragment key="50">50</Fragment>
                     <Fragment key="100">100</Fragment>
                  </DropdownField>
                  <span>{trans('?par page')}</span>
                  {pagesButtons}
               </div>
            </div>
            {isInfoVisible && <div className={`${styles.product_info} ${showInfoDown ? styles.info_down : ''}`}>
               <header>
                  <div>
                     <h2>{subTitle}</h2>
                     <h1>{selectedModel?.label || ''}</h1>
                  </div>
                  <Button onClick={doHideInfo}>
                     {trans('?Fermer')}
                  </Button>
               </header>
               <div className={styles.info_detail}>
                  {!zoomed &&
                     <div className={styles.detail_left}>
                        <div className={styles.info_block}>
                           <h3>{trans('?Détail', true)}</h3>
                           <div className={styles.info_block_detail}>
                              <span>
                                 <span>
                                    <FontAwesomeIcon icon={faRing} />
                                 </span>
                                 {/* {`${formatWeightWithNC(selectedModel.pds)}`} */}
                                 _PDS_
                              </span>
                              <span>
                                 <span>
                                    <FontAwesomeIcon icon={faGem} />
                                 </span>
                                 {/* {`${formatDiamWeightWithNC(selectedModel.pdsdts)}`} */}
                                 _PDSDTS_
                              </span>
                              <span>
                                 <span>
                                    <FontAwesomeIcon icon={faCubesStacked} />
                                 </span>
                                 {/* {`${formatNumberWithNC(selectedModel.dts)}`} */}
                                 _DTS_
                              </span>
                              <span>
                                 <span>
                                    <FontAwesomeIcon icon={faBox} />
                                 </span>
                                 {/* {selectedModel.ecrin} */}
                                 _ECRIN_
                              </span>
                           </div>
                        </div>
                        <div className={styles.info_block}>
                           <h3>{trans('?Couleur', true)}</h3>
                           <div className={styles.info_block_colors}>
                              {"_arrColorsForSelectedModel_a_virer_"}
                           </div>
                        </div>
                        <div className={`${styles.info_block} ${styles.description}`}>
                           <h3>{trans('?Description')}</h3>
                           {/* <span>{selectedModel.descr[currentLang ?? 'fr']}</span> */}
                           <span>_descr[currentLang]_</span>
                        </div>
                     </div>
                  }
                  <div className={styles.detail_right}>
                     {!zoomed &&
                        <div className={styles.info_block}>
                           <div className={styles.prix_public}>
                              <div className={styles.prix}>
                                 <span>{trans('?Prix public')}</span>
                                 <span>{"_formatPPUPrice(minMaxForSelectedModel?.min)_a_virer_"}</span>
                              </div>
                              {/* <span className={styles.cycle}>{getCycleById(selectedModel.cycle).label}</span> */}
                              <span className={styles.cycle}>_CYCLE_</span>
                           </div>
                        </div>
                     }
                     <div className={`${styles.info_block} ${styles.info_block_thumbnails} ${zoomed ? styles.zoomed : ''}`}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.magnify} onClick={() => setZoomed(val => !val)} />
                        {selectedModel &&
                           <>
                              <DynImage className={styles.imgmodel} src={[`catalogue/ecrins/${selectedModel.id}.jpg`, selectedModel.bymessika ? selectedModel.bymessika[selectedThumb] : null]} alt={`Item ${selectedModel.id}`} />
                              {(selectedModel.bymessika?.length > 1) &&
                                 <div className={styles.thumbnails}>
                                    {selectedModel.bymessika.map((an_image, idx) => {
                                       const num = idx
                                       return <img className={`${styles.imgmodel_thumb} ${(num === selectedThumb) ? styles.selected : ''} `} src={`https://www.bymessika.com/media/catalog/product${an_image}`} alt={`Model ${selectedModel.id}`} onClick={() => setSelectedThumb(num)} />
                                    })}
                                 </div>
                              }
                           </>
                        }
                     </div>
                  </div>
               </div>
            </div>
            }
         </div>
         {theQtyPicker}
         {duplicateLineDialog && (
            <Confirm
               title={trans('?SKU déjà présent')}
               text={
                  <>
                     <div>{transWithParams('?sku_duplicate_info', [duplicateLineDialog.line.sku, duplicateLineDialog.existingQty])}</div>
                     <div>{transWithParams('?sku_duplicate_question', [duplicateLineDialog.line.qty, duplicateLineDialog.existingQty + duplicateLineDialog.line.qty])}</div>
                  </>
               }
               onOK={onReplaceDuplicate}
               onCancel={onCancelDuplicate}
               okLabel={trans('?Remplacer')}
               middleButton={{ label: trans('?Cumuler'), onClick: onCumulateDuplicate }}
            />
         )}
         <ToastContainer />
      </Fragment>
   )
}

export default RetailCatalogDetail;
